import { useNavigate } from 'react-router-dom'
import { TypographyStyles } from '@/styles'
import { Button, Image, Text } from '@/ui'
import { useTherapistFlag, CaseStyle } from '@/utils/launchdarklyHelpers'

export const CancellationPrevented = () => {
  const navigate = useNavigate()
  const replacementText = useTherapistFlag(CaseStyle.lowerCase, false)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-center">
        <Image
          alt="Party hat with confetti"
          src="https://heard-images.s3.amazonaws.com/assets/party-hat.svg"
          height={180}
          width={180}
        />
      </div>

      <Text
        textAlign="center"
        variant={TypographyStyles.H1}
        className="w-full md:w-1/2 mx-auto"
      >
        We&apos;re delighted that you&apos;re choosing to stay with us!
      </Text>

      <Text
        variant={TypographyStyles.BODY_LG}
        className="w-full md:w-5/8 mx-auto"
      >
        We&apos;re always working to improve Heard to address our{' '}
        {replacementText}
        community&apos;s feedback and are glad that you&apos;ll be able to take
        advantage of all your benefits.
      </Text>

      <div className="flex justify-center">
        <Button onClick={() => navigate('/')}>Go to Home</Button>
      </div>
    </div>
  )
}
